export const sendWebviewMessage = (message) => {
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify(message));
};
